import React, { useEffect, useState } from "react";
import "./SearchHeader.scss";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import InsRadioSearch from "../../../../components/InsRadioSearch/InsRadioSearch";

import images from "ressources/images";
import SearchFiltersMenu from "../SearchFiltersMenu/SearchFiltersMenu";

const SearchHeader = ({
  sortBy,
  onSortChange,
  toggleFiltersMenu,
  openFiltersMenu,
  filters,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [openSortMenu, setopenSortMenu] = useState(false);
  // const [sortBy, setsortBy] = useState("recent");

  const handleSortChange = (sort) => {
    // setsortBy(sort);
    onSortChange(sort);
    setopenSortMenu(false);
  };

  const hasFilters =
    filters.brands.length > 0 ||
    filters.types.length > 0 ||
    filters.categories.length > 0;

  const goBack = () => {
    history.push("/search");
  };

  const name = new URLSearchParams(useLocation().search).get("query");

  return (
    <>
      <div className="search_header_grid">
        <div className="grid-left">
          {name && !openFiltersMenu ? (
            <div>
              <button onClick={() => goBack()}>
                <div className="arrow brands_header_back"></div>
              </button>
            </div>
          ) : null}
        </div>
        <div className="grid-middle">
          <p>{name ? name : t("filter")}</p>
        </div>
        <div className="grid-right">
          {!openFiltersMenu ? (
            <>
              <button onClick={toggleFiltersMenu}>
                <img
                  alt="filter"
                  src={hasFilters ? images.filter_selected : images.filter}
                ></img>
              </button>
              <button onClick={() => setopenSortMenu(!openSortMenu)}>
                <img alt="filter" src={images.sort_on}></img>
              </button>
            </>
          ) : (
            <button onClick={toggleFiltersMenu}>
              <img alt="filter" src={images.closeCross}></img>
            </button>
          )}
        </div>
      </div>
      {openSortMenu && (
        <div className="search_header_sort_menu">
          <div className="search_header_sort_label">{t("Sort by")} :</div>
          <InsRadioSearch
            key={"recent"}
            value={"recent"}
            name={"sortby-recent"}
            label={t("Recent")}
            checked={sortBy === "recent"}
            onChange={() => handleSortChange("recent")}
          />
          <InsRadioSearch
            key={"views"}
            value={"views"}
            name={"sortby-views"}
            label={t("Viewed")}
            checked={sortBy === "views"}
            onChange={() => handleSortChange("views")}
          />
        </div>
      )}
    </>
  );
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  searchFilterList: state.searchFilters,
});


export default withTranslation()(
    connect(mapStateToProps)(SearchHeader)
);
